module.exports = __webpack_public_path__ + "assets/media/2.42e8f22a.wav";